import React from "react";
import BasePaywall from "app/components/paywalls/BasePaywall";
import coachnowProLogo from "app/images/coachnow_pro_logo.svg";
import styles from "./styles.module.scss";

type PropsDef = {
  show?: boolean;
  onClose?: () => void;
};

export default function ExplicitPaywall({ show, onClose }: PropsDef) {
  return (
    <BasePaywall
      show={show}
      onClose={onClose}
      title="Upgrade to CoachNow PRO"
      image={coachnowProLogo}
      imageClassname={styles.image}
      returnUrl="/spaces"
      featureName="Space Limit"
    />
  );
}
